/*************************************************/
/* SLIDER                                        */
/*************************************************/
require("../vendor/jquery.flexslider.js");

export function slider() {

    const init = function () {

        $("#slider").flexslider({
            animation: "slide",
            useCSS: true,
            touch: true,
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            sync: "#carousel"
        });

        $("#carousel").flexslider({
            animation: "slide",
            useCSS: true,
            touch: true,
            controlNav: true,
            animationLoop: false,
            //directionNav: false,
            slideshow: false,
            itemWidth: 100,
            itemMargin: 7.5,
            asNavFor: "#slider"
        });

    }
    init();
}